import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import { GetProducts } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { globalLang } from '~globalLang'

interface Props {
    onClose: () => void
    fieldName?: string
    product?: GetProducts
}

function Content({ onClose, fieldName }: Props) {
    const intl = useIntl()

    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Error} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} values={{ fieldName: fieldName?.toLowerCase() }} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="mistake_modal"
        >
            <div className={s.button}>
                <Button dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.cancel} />
                </Button>
                <Button dataPointer="contact" size="l" mode="primary" href={supportLink} role="anchor" fullWidth>
                    <FormattedHTMLMessage {...lang.contact} />
                </Button>
            </div>
        </ModalView>
    )
}

export default Content
